export default __webpack_public_path__ + "static/media/object--bike-rack.2d333cd5.png";